import { useMemo } from "react";
import { selectPrices, useSelector } from "@jti/store";
const useCurrentPrice = (isFreeTrial, isStandardCheckoutFlow, selectedOrderDetails) => {
    const pricesList = useSelector(selectPrices);
    const trialCartPrices = useSelector((state) => state.freeTrialCart.prices);
    return useMemo(() => {
        if (isFreeTrial && trialCartPrices.data) {
            return trialCartPrices.data;
        }
        if (!isFreeTrial && isStandardCheckoutFlow === false) {
            return selectedOrderDetails?.prices ?? null;
        }
        if (!isFreeTrial && (isStandardCheckoutFlow || isStandardCheckoutFlow === null)) {
            return pricesList;
        }
        return null;
    }, [isFreeTrial, trialCartPrices.data, isStandardCheckoutFlow, selectedOrderDetails?.prices, pricesList]);
};
export default useCurrentPrice;
//# sourceMappingURL=useCurrentPrice.js.map